"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _errorHandlerUtility = _interopRequireDefault(require("../utils/errorHandlerUtility"));
var _constants = require("../constants");
var _staticContent = require("../staticContent");
var _navigateTo = require("../utils/navigateTo");
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _redirectUrl = require("../utils/redirectUrl");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SubmitMessage = props => {
  var {
    backendErrored,
    formMetaData,
    fields,
    error,
    hasSubmitted,
    language,
    locale,
    submissionID,
    successfulSubmitBlock = false,
    unsuccessfulSubmitBlock = false
  } = props;
  var metaData = (0, _utils.getMetaData)();
  var {
    showSummary
  } = formMetaData;
  var setFieldsTrue = fields => {
    if (!fields || !Array.isArray(fields) || !fields.length) {
      return;
    }
    fields === null || fields === void 0 || fields.map(item => {
      if (item.isConditionalField) {
        item === null || item === void 0 || item.options.map(option => {
          var _option$conditionalFi;
          if (option !== null && option !== void 0 && (_option$conditionalFi = option.conditionalFieldGroup) !== null && _option$conditionalFi !== void 0 && _option$conditionalFi.fields) {
            return setFieldsTrue(option.conditionalFieldGroup.fields);
          }
          return null;
        });
      }
      if ((item === null || item === void 0 ? void 0 : item.type) === 'fieldGroup') {
        return setFieldsTrue(item === null || item === void 0 ? void 0 : item.fields);
      }
      item.isReadOnly = true;
      return null;
    });
  };
  var CenteredLoadingSpinner = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        height: '100vh',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, {
      horizontalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, {
      verticalAlign: "middle"
    }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      locale: locale,
      language: language
    })))));
  };
  var fieldValues = (0, _redirectUrl.createFieldValuesObject)(formMetaData === null || formMetaData === void 0 ? void 0 : formMetaData.fields);

  // Flat object used as arg in redirectUrl()
  var combinedObj = _objectSpread(_objectSpread(_objectSpread({}, fieldValues), metaData), {}, {
    submissionID
  });
  (0, _react.useLayoutEffect)(() => {
    setFieldsTrue((formMetaData === null || formMetaData === void 0 ? void 0 : formMetaData.fields) || []);
    setFieldsTrue((formMetaData === null || formMetaData === void 0 ? void 0 : formMetaData.consentField) || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formMetaData === null || formMetaData === void 0 ? void 0 : formMetaData.fields, formMetaData === null || formMetaData === void 0 ? void 0 : formMetaData.consentField]);
  var {
    postSubmissionToggle,
    postSubmissionMessage,
    unsuccessfulSubmissionToggle,
    unsuccessfulSubmissionMessage
  } = formMetaData;
  if (!error && !backendErrored && hasSubmitted && postSubmissionToggle === _constants.SUBMISSION_MESSAGE_TYPES.Link && postSubmissionMessage) {
    if (postSubmissionMessage !== _staticContent.FORM_COMPONENT.THANK_YOU_MESSAGE[language]) {
      var newUrl = (0, _redirectUrl.redirectUrl)(postSubmissionMessage, combinedObj);
      (0, _navigateTo.navigateTo)(window.location.origin + '/' + newUrl);
      return CenteredLoadingSpinner();
    }
  } else if ((error || backendErrored) && hasSubmitted && unsuccessfulSubmissionToggle === _constants.SUBMISSION_MESSAGE_TYPES.Link && unsuccessfulSubmissionMessage) {
    var errorInfo = {
      unsuccessfulRedirectURL: window.location.origin + '/' + unsuccessfulSubmissionMessage,
      hasSubmitted,
      unsuccessfulSubmissionToggle
    };
    _errorHandlerUtility.default.report(JSON.stringify({
      message: 'Submission errored, redirect to failing URL',
      error,
      errorInfo,
      fileName: 'SubmitMessage.jsx',
      methodName: 'submitMessage'
    }));
    if (unsuccessfulSubmissionMessage !== _staticContent.FORM_COMPONENT.UNSUCCESSFUL_MESSAGE[language]) {
      (0, _navigateTo.navigateTo)(window.location.origin + '/' + unsuccessfulSubmissionMessage);
      return CenteredLoadingSpinner();
    }
  }
  return backendErrored ? unsuccessfulSubmitBlock ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    vertical: 2,
    key: "unsuccessful-submit-message-box"
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, null, formMetaData.unsuccessfulSubmissionMessage)) : successfulSubmitBlock ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    vertical: 2,
    key: "submit-message-box"
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, null, formMetaData.postSubmissionMessage), showSummary === 'Yes' && fields);
};
SubmitMessage.propTypes = {
  backendErrored: _propTypes.default.bool.isRequired,
  formMetaData: _propTypes.default.object.isRequired
};
var _default = exports.default = SubmitMessage;